import {
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import { storage } from "./config";

/**
 * Upload an image file to Firebase Storage
 * @param {File} file - The file to upload
 * @param {string} folder - The folder to upload to (default: "orders")
 * @returns {Promise<string>} The download URL of the uploaded file
 */
export const uploadImage = async (file, folder = "orders") => {
  if (!file) throw new Error("No file provided");
  const fileName = `nm-india-bio/${folder}/${Date.now()}-${file.name}`;

  const imageRef = ref(storage, fileName);
  await uploadBytes(imageRef, file);
  return await getDownloadURL(imageRef);
};

/**
 * Delete an image from Firebase Storage using its URL
 * @param {string} url - The URL of the image to delete
 * @returns {Promise<void>}
 */
export const deleteImageByUrl = async (url) => {
  if (!url) throw new Error("No URL provided");

  // Extract path from URL
  const baseUrl = `https://firebasestorage.googleapis.com/v0/b/${storage.app.options.storageBucket}/o/`;
  const imagePath = decodeURIComponent(url.replace(baseUrl, "").split("?")[0]);

  const imageRef = ref(storage, imagePath);
  await deleteObject(imageRef);
};
